import Icon from '../components/Icon.vue'

Icon.register({
  'shopping-bag': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M352 160h96v272c0 44.2-35.8 80-80 80h-288c-44.2 0-80-35.8-80-80v-272h96v-32c0-70.6 57.4-128 128-128 70.6 0 128 57.4 128 128v32zM160 128v32h128v-32c0-35.3-28.7-64-64-64s-64 28.7-64 64zM320 248c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24zM128 248c13.3 0 24-10.7 24-24s-10.7-24-24-24-24 10.7-24 24 10.7 24 24 24z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/shopping-bag.js
// module id = 1882
// module chunks = 0